<template lang="pug">
  hotsite-dgc
    .conteudo
      bloco.-nomargin.-softpadding.-fullheight
        //- HEADER
        header(slot="header")
          titulo.-withbar.-upper Sobre a DGC
        //- CONTENT
        .texto(slot="content")
          p.
            A Diretoria de Contratos tem a finalidade de planejar,
            acompanhar a execução físico-financeira e coordenar a
            fiscalização administrativa dos contratos de obras e serviços de
            engenharia, cessão patrimonial e de serviços de natureza
            continuada, em consonância com as políticas e diretrizes de
            governança em contratações e aquisições regulamentadas pelo
            Conselho de Administração da UFRN.
          p A Diretoria de Contratos é constituída por:
          ul
            li Divisão de Formalização e Acompanhamento de Contratos
            li Divisão de Fiscalização de Contratos
        //- FOOTER
        footer(slot="footer")
          back-and-share
</template>

<script>
  import BackAndShare from 'COMPONENTS/BackAndShare'
  import Bloco from 'COMPONENTS/Bloco'
  import Cover from 'COMPONENTS/ImagemCover'
  import HotsiteDgc from 'PAGES/dgc/Base'
  import Listagem from 'COMPONENTS/BaseLista'
  import Titulo from 'COMPONENTS/ElementTitle'

  export default {
    components: {
      BackAndShare,
      Bloco,
      Cover,
      HotsiteDgc,
      Listagem,
      Titulo
    }
  }
</script>



// WEBPACK FOOTER //
// Sobre.vue?c6a269c6